import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css, token }: any) => ({
  root: css``,
  avatar: css`
    cursor: pointer;
    background: ${token.ColorFigmaNeutralGrayscaleGray30};
  `,
  avatarUploadImage: css``,
  avatarUploadButton: css``,
  hiddenInput: css`
    display: none !important;
  `,
}));

export const useAvatarStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
